import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_layout_2x2",
  "use": "icon-icon_layout_2x2-usage",
  "viewBox": "0 0 60 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 45\" id=\"icon-icon_layout_2x2\">\n<path d=\"M0,0v45h60V0H0z M59,22H30.5V1H59V22z M29.5,1v21H1V1H29.5z M1,23h28.5v21H1V23z M30.5,44V23H59v21H30.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol